import { render, staticRenderFns } from "./BalanceAgeeImportModal.vue?vue&type=template&id=870a62d2"
import script from "./BalanceAgeeImportModal.vue?vue&type=script&lang=ts"
export * from "./BalanceAgeeImportModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports